export enum ACCOUNT_STATEMENT_ACTIONS {
  SET_IS_ACCOUNT_STATEMENT_UI_ENABLED = 'USER_INFO_ACTIONS.SET_IS_ACCOUNT_STATEMENT_UI_ENABLED',
  GET_ACCOUNT_OPTIONS = 'USER_INFO_ACTIONS.GET_ACCOUNT_OPTIONS',
  SET_ACCOUNT_STATEMENT_FILTER_VALUES = 'USER_INFO_ACTIONS.SET_ACCOUNT_STATEMENT_FILTER_VALUES',
  GET_DOWNLOAD_URLS = 'USER_INFO_ACTIONS.GET_DOWNLOAD_URLS',
}
